/**
 * The window event that tells the layout to recount the invites badge when the
 * games tab accepts or declines one (issue 500 §4).
 *
 * It lives apart from `GamesCard` so the layout, which is in the main chunk,
 * can listen for it without pulling the account page's games tab in with it
 * (12 kB of the main script, measured 2026-10-15).
 */
export const INVITES_CHANGED_EVENT = 'tdt:invites-changed';
